<template>
  <div id="banks" class="col-12 p-0">
    <div class="row-center">
      <div>
        <!-- CREAR -->

        <!-- 1 MODAL CREACIÓN BANCO -->

        <b-modal id="modal-create-bk" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">agregar Banco</h2>
            <div class="baseline_box d-flex mr-0 align-items-center" id="baseline_box">
              <input v-model="nameLN" type="text" autocomplete="off" class="input-text" style="width: 390px"
                placeholder="Nombre del Banco" @click="changeborder(true)" @blur="changeborder(false)" />
              <label class="label-helper" for="inputpwdCurrent">Nombre del Banco</label>
            </div>
            <div class="baseline_box d-flex mr-0 align-items-center" id="baseline_box2">
              <input v-model="code" type="number" autocomplete="off" class="input-text" style="width: 390px"
                placeholder="Código" @click="changeborder2(true)" @blur="changeborder2(false)" />
              <label class="label-helper" for="inputpwdCurrent">Ingresa código</label>
            </div>
            <div class="mt-4 d-flex">
              <SaveModal :disabled="code == '' || nameLN == ''" @click="nextStep1PS('next')">
                Guardar cambios
              </SaveModal>

              <CancelModal @click="$bvModal.hide('modal-create-bk')">Cancelar</CancelModal>
            </div>
          </div>
        </b-modal>

        <!-- 2 MODAL CREACIÓN BANCO CONFIRMACIÓN -->

        <b-modal id="modal-create2-bk" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1 mb-4" src="@/assets/images/icons/warning_.svg" width="15%" />
            <h2 class="pt-2 font-weight-bold">
              ¿Estás seguro de guardar este Banco?
            </h2>
            <p class="pt-2 mb-1">
              <span class="text-uppercase font-weight-bold">{{ nameLN }}</span>
            </p>
            <p style="font-size: 16px" class="mt-1">
              <span class="font-weight-bold">Código: </span>{{ code }}
            </p>
            <div class="mt-4 d-flex">
              <PreviusEditModal @click="nextStep1PS('previous')">
                Seguir Editando
              </PreviusEditModal>
              <SaveModal @click="nextStep1PS('save')">
                Guardar cambios
              </SaveModal>
            </div>
          </div>
        </b-modal>

        <!-- 3 MODAL CREACIÓN BANCO -- EXITOSO  -->

        <b-modal id="modal-success" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1" src="@/assets/images/icons/checkbox-circle-line.svg" />
            <h2 class="pt-5 font-weight-bold">¡Proceso exitoso!</h2>
            <label class="pb-2 table-value" style="color: #455a64; margin-bottom: 16px">{{ message.message }}</label>
            <OkayModal @click="$bvModal.hide('modal-success')">
              Entendido
            </OkayModal>
          </div>
        </b-modal>

        <!-- 3 MODAL FALLO DE OPERACIÓN -- FALLIDO -->

        <b-modal v-if="error.trace" id="modal-fail" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1" src="@/assets/images/icons/close.svg" width="20%" />
            <h2 class="pt-5 font-weight-bold">¡Proceso fallido!</h2>
            <label class="pb-2 table-value" style="color: #455a64; margin-bottom: 16px">{{ error.trace.message[0]
            }}</label>
            <OkayModal @click="$bvModal.hide('modal-fail')">
              Entendido
            </OkayModal>
          </div>
        </b-modal>

        <!-- EDITAR/ELIMINAR -->

        <!-- 1 MODAL EDICIÓN BANCO -->

        <b-modal id="modal-edit-bk" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">Editar Banco</h2>
            <div class="baseline_box d-flex mr-0 align-items-center" id="baseline_box">
              <input v-model="nameLN" type="text" autocomplete="off" class="input-text" style="width: 390px"
                placeholder="Nombre del Banco" @click="changeborder(true)" @blur="changeborder(false)" />
              <label class="label-helper" for="inputpwdCurrent">Nombre del Banco</label>
            </div>
            <div class="baseline_box d-flex mr-0 align-items-center" id="baseline_box2">
              <input v-model="code" type="number" autocomplete="off" class="input-text" style="width: 390px"
                placeholder="Código" @click="changeborder2(true)" @blur="changeborder2(false)" />
              <label class="label-helper" for="inputpwdCurrent">Ingresa código</label>
            </div>

            <div class="mt-4 d-flex">
              <SaveModal :disabled="checkEdit" @click="nextStep2PS('next')">
                Guardar cambios
              </SaveModal>

              <DelModal @click="nextStep2PS('nextD')">
                Borrar Banco
              </DelModal>
            </div>
          </div>
        </b-modal>

        <!-- 2 MODAL CONFIRMACIÓN EDICIÓN BANCO -->

        <b-modal id="modal-edit2-bk" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1 mb-4" src="@/assets/images/icons/warning_.svg" width="15%" />
            <h3 class="pt-5 font-weight-bold">
              ¿Estás seguro de modificar este Banco?
            </h3>
            <p class="pt-5">
              <span class="text-uppercase font-weight-bold">{{ nameLN }}</span>
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Código: </span>{{ code }}
            </p>
            <div class="mt-4 d-flex">
              <PreviusEditModal @click="nextStep2PS('previous')">
                Seguir Editando
              </PreviusEditModal>
              <SaveModal @click="nextStep2PS('edit')">
                Guardar cambios
              </SaveModal>
            </div>
          </div>
        </b-modal>

        <!-- 4 MODAL ELIMINAR BANCO -->

        <b-modal id="modal-delete-bk" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1 mb-4" src="@/assets/images/icons/warning_.svg" width="15%" />
            <h2 class="pt-2 font-weight-bold">
              ¿Estás seguro de eliminar el Banco?
            </h2>
            <p class="pt-2 text-danger">
              Al confirmar no podrás recuperar los cambios.
            </p>
            <p class="pt-2">
              <span class="text-uppercase">{{ nameLN }}</span>
            </p>
            <div class="mt-4 d-flex">
              <NoDelModal @click="nextStep2PS('previous')">
                No borrar
              </NoDelModal>

              <DelModal @click="nextStep2PS('delete')">
                Borrar Banco
              </DelModal>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
    <div class="row">
      <SelectSettings />
      <!-- Boton Crear Banco -->
      <div class="col-lg-4 col-sm-12 mt-4">
        <AddCategory text="Agregar Banco +" @nuevo="create"></AddCategory>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-sm-12">
        <div class="mb-4 card-personalizada">
          <div class="card-header card-header-left">
            <h3 style="color:color: #263238;">Lista de Bancos</h3>
          </div>
          <div class="col-12">
            <div class="buscar-empleado mt-4 mb-4">
              <div class="input-group-prepend">
                <span class="icon icon-search1"></span>
              </div>
              <input type="search" placeholder="Buscar Banco" aria-label="Buscar Banco" autocomplete="off"
                class="form-control body_regular" v-model="filter" style="border: 0px" @keydown="startTipyng()"
                @keyup="finishTipyng()" />
            </div>
          </div>
          <div class="mt-5" v-if="loading" id="loader"></div>
          <div v-else class="col-12 ml-1 mt-2 mb-1 mr-2">
            <datatable :columns="datatable.columns" :data="datatable.rows" :per-page="datatable.perPage"
              :page="datatable.page" class="col-12 mt-5 table table-hover table-borderless">
              <template slot-scope="{ row, columns }">
                <tr @click="editBank(row)">
                  <template>
                    <datatable-cell v-for="(column, j) in columns" :key="j" :column="column" :row="row">
                    </datatable-cell>
                  </template>
                </tr>
              </template>
            </datatable>
            <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
              <Pagination :data="banks.data" :limit="10" @pagination-change-page="getFilterDp">
                <template #prev-nav>
                  <span>&lt;</span>
                </template>
                <template #next-nav>
                  <span>&gt;</span>
                </template>
              </Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Pagination from "laravel-vue-pagination";
import SelectSettings from "@/components/platformSettings/selectSettings.vue";
import DelModal from "@/components/core/button/del-modal.vue";
import SaveModal from "@/components/core/button/save-modal.vue";
import CancelModal from "@/components/core/button/cancel-modal.vue";
import PreviusEditModal from "@/components/core/button/cancel-modal.vue";
import OkayModal from "@/components/core/button/okay-modal.vue";
import NoDelModal from "@/components/core/button/no-del-modal.vue";
import AddCategory from "@/components/core/button/add-category.vue";

export default {
  name: "Banks",
  components: {
    Pagination,
    SelectSettings,
    DelModal,
    NoDelModal,
    SaveModal,
    CancelModal,
    PreviusEditModal,
    OkayModal,
    AddCategory
  },
  data() {
    return {
      runtime: "",
      selectedlb: { id: 0, name: "default" },
      optionslb: [
        { value: { id: 0, name: "default" }, text: "Asigna una categoria" },
      ],
      code: "",
      indexRow: 0,
      nameLN: "",
      modalCreateNew: "",
      filter: "",
      datatable: {
        total: 18,
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      },
    };
  },
  beforeMount() {
    this.getBanks();
  },
  computed: {
    ...mapState("modPlatformSettings", [
      "typeOfList",
      "banks",
      "bank",
      "loading",
      "error",
      "message",
    ]),

    checkEdit: function () {
      return this.nameLN === "";
    },
  },
  methods: {
    ...mapActions("modPlatformSettings", [
      "actSelectOptions",
      "actbanks",
      "actGetBank",
      "actSaveBank",
      "actActBank",
      "actDelBank",
    ]),

    changeborder(change) {
      if (change) {
        document.getElementById("baseline_box").style.borderColor = "#5D5FEF";
      } else {
        document.getElementById("baseline_box").style.borderColor = "#78909C";
      }
    },
    changeborder1(change) {
      if (change) {
        document.getElementById("baseline_box1").style.borderColor = "#5D5FEF";
      } else {
        document.getElementById("baseline_box1").style.borderColor = "#78909C";
      }
    },
    changeborder2(change) {
      if (change) {
        document.getElementById("baseline_box2").style.borderColor = "#5D5FEF";
      } else {
        document.getElementById("baseline_box2").style.borderColor = "#78909C";
      }
    },
    getBanks() {
      let data = [];
      data = {
        page: this.datatable.page,
        type_list_id: this.typeOfList.banks,
      };

      this.actSelectOptions(data).then(() => {
        if (this.banks.data.data) {
          this.banks.data.data.forEach((x) => {
            this.datatable.rows.push({
              id: x.id,
              code: x.code,
              name: x.name,
            });
          });
        }
      });
      this.loadRows();
    },

    startTipyng() {
      clearTimeout(this.runTime);
    },
    finishTipyng() {
      this.runTime = setTimeout(() => {
        this.getFilterDp();
      }, 1500);
    },

    create() {
      this.nameLN = "";
      this.code = "";
      this.$root.$emit("bv::show::modal", "modal-create-bk");
    },
    nextStep1PS(x) {
      let data = {
        name: this.nameLN,
        code: this.code,
        type_list_id: this.typeOfList.banks,
      };
      switch (x) {
        case "next":
          this.$root.$emit("bv::hide::modal", "modal-create-bk");
          this.$root.$emit("bv::show::modal", "modal-create2-bk");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-create2-bk");
          this.$root.$emit("bv::show::modal", "modal-create-bk");
          break;
        case "save":
          this.actSaveBank(data).then(() => {
            if (this.error.data) {
              this.$root.$emit("bv::hide::modal", "modal-create2-bk");
              this.$root.$emit("bv::show::modal", "modal-fail");
              this.getBanks();
              return;
            } else {
              this.nameLN = "";
              this.code = "";
              this.$root.$emit("bv::hide::modal", "modal-create2-bk");
              this.$root.$emit("bv::show::modal", "modal-success");
              this.getBanks();
            }
          });
          break;
        default:
      }
    },
    loadRows() {
      this.datatable = {
        total: 18,
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      };
      this.datatable.columns = [
        {
          label: "Banco",
          field: "name",
          align: "left",
          headerClass: "theading",
        },
        {
          label: "Codigo",
          field: "code",
          align: "left",
          headerClass: "theading",
        },
      ];
    },
    editBank(row) {
      this.actGetBank(row.id).then(() => {
        this.nameLN = this.bank.name;
        this.code = this.bank.code;
        this.indexRow = this.bank.id;
        this.$root.$emit("bv::show::modal", "modal-edit-bk");
        this.getBanks();
      });
    },
    nextStep2PS(x) {
      let data = {
        name: this.nameLN,
        type_list_id: this.typeOfList.banks,
        code: this.code,
        id: this.indexRow,
      };
      switch (x) {
        case "next":
          this.$root.$emit("bv::hide::modal", "modal-edit-bk");
          this.$root.$emit("bv::show::modal", "modal-edit2-bk");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-edit2-bk");
          this.$root.$emit("bv::hide::modal", "modal-delete-bk");
          this.$root.$emit("bv::show::modal", "modal-edit-bk");
          break;
        case "edit":
          this.actActBank(data).then(() => {
            if (this.error.data) {
              this.nameLN = "";
              this.code = "";
              this.$root.$emit("bv::hide::modal", "modal-create2-bk");
              this.$root.$emit("bv::show::modal", "modal-fail");
              return;
            } else {
              this.nameLN = "";
              this.code = "";
              this.$root.$emit("bv::hide::modal", "modal-edit2-bk");
              this.$root.$emit("bv::show::modal", "modal-success");
              this.getBanks();
            }
          });
          break;
        case "nextD":
          this.$root.$emit("bv::hide::modal", "modal-edit-bk");
          this.$root.$emit("bv::show::modal", "modal-delete-bk");
          break;
        case "delete":
          this.actDelBank(data.id)
            .then(() => {
              this.nameLN = "";
              this.code = "";
              this.$root.$emit("bv::hide::modal", "modal-delete-bk");
              this.$root.$emit("bv::show::modal", "modal-success");
              this.getBanks();
            })
            .catch((error2) => {
              this.nameLN = "";
              this.code = "";
              let error = {
                trace: {
                  message: [error2.response.data.message],
                },
              };
              this.actSetError(error).then(() => {
                this.$root.$emit("bv::hide::modal", "modal-delete-bk");
                this.$root.$emit("bv::show::modal", "modal-fail");
                this.getBanks();
              });
            });
          break;
        default:
      }
    },

    getFilterDp(page = 1) {
      /*if (this.filter !== "") {
        console.log("log");
      }*/
      let data = {
        type_list_id: this.typeOfList.banks,
        page: page,
        filter: this.filter,
      };

      this.actSelectOptions(data).then(() => {
        this.loadRows();
        if (this.banks.data.data) {
          this.banks.data.data.forEach((x) => {
            this.datatable.rows.push({
              id: x.id,
              code: x.code,
              name: x.name,
            });
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
#banks {
  input {
    /* body regular */
    font-family: Ubuntu;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 28px;

    border: 0;

    &:focus,
    &:active {
      outline: 0;
      border: 0;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      box-shadow: none;
    }
  }

  .buscar-empleado {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;

    position: relative;
    width: 428px !important;
    height: 44px;
    //left: 30px;
    top: calc(50% - 44px / 2);
    margin-bottom: 24px;

    background: #ffffff;
    /* content/03 */

    border: 1px solid #b0bec5;
    border-radius: 22px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 16px 0px;
  }

  .buscar-empleado .form-control {
    border: 0px !important;
    font-family: Ubuntu !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 16px !important;
    line-height: 28px !important;
  }

  .card-header-left {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    border-bottom: none;

    widows: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .card-header-text {
    /* Header Tablas */

    font-style: normal;
    //background: #F5F5F5;
    font-size: 16px;
    /* identical to box height */
    /* Alert/Succes */
    color: #263238 !important;
    width: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .card-personalizada {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    position: static;
    background: #ffffff;
    border: 0px solid #eceff1 !important;
    box-sizing: border-box;
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 12px !important;
    flex: none;
    order: 0;
    flex-grow: 0;
    //margin: 24px 0px;
  }

  select.custom-select {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }

  .table-views {
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 8px;
    padding: 0;
    margin: 30px 5px;

    .t-head {
      background-color: #f5f5f5;
      padding: 5px 15px;
      text-align: left;
    }

    input {
      padding: 10px 10px;
      font-size: 15px;
      height: 50px;
      border-radius: 10px;
    }

    thead tr {
      background-color: #eef2fa;
      border-radius: 10px;
      text-align: left;
    }

    .theading {
      padding: 15px 15px;
    }

    tbody tr {
      border-radius: 10px;
    }

    tbody tr td {
      padding: 15px 15px;
      cursor: pointer;
    }

    tbody tr:hover {
      background-color: #f5f5f5;
    }
  }
}
</style>